// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccessTypeController from "./access_type_controller"
application.register("access-type", AccessTypeController)

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatPanelController from "./chat_panel_controller"
application.register("chat-panel", ChatPanelController)

import ChatSidebarController from "./chat_sidebar_controller"
application.register("chat-sidebar", ChatSidebarController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GoalEditController from "./goal_edit_controller"
application.register("goal-edit", GoalEditController)

import GoalsFormController from "./goals_form_controller"
application.register("goals-form", GoalsFormController)

import GoalsPanelController from "./goals_panel_controller"
application.register("goals-panel", GoalsPanelController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvitationModalController from "./invitation_modal_controller"
application.register("invitation-modal", InvitationModalController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MemoryController from "./memory_controller"
application.register("memory", MemoryController)

import MessageActionsController from "./message_actions_controller"
application.register("message-actions", MessageActionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RequestAccessModalController from "./request_access_modal_controller"
application.register("request-access-modal", RequestAccessModalController)

import DeclineReasonModalController from "./decline_reason_modal_controller"
application.register("decline-reason-modal", DeclineReasonModalController)


import VoiceStreamingController from "./voice_streaming_controller"
application.register("voice-streaming", VoiceStreamingController)

import LivekitStreamingController from "./livekit_streaming_controller"
application.register("livekit-streaming", LivekitStreamingController)

import LivekitVoiceController from "./livekit_voice_controller"
application.register("livekit-voice", LivekitVoiceController)

import NudgeSettingsController from "./nudge_settings_controller"
application.register("nudge-settings", NudgeSettingsController)

import PaymentMethodModalController from "./payment_method_modal_controller"
application.register("payment-method-modal", PaymentMethodModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import CharacterCountController from "./character_count_controller"
application.register("character-count", CharacterCountController)

import LanguageSelectorController from "./language_selector_controller"
application.register("language-selector", LanguageSelectorController)

import LearningOutcomesController from "./learning_outcomes_controller"
application.register("learning-outcomes", LearningOutcomesController)

import TutorVoiceController from "./tutor_voice_controller"
application.register("tutor-voice", TutorVoiceController)

import TutorSttController from "./tutor_stt_controller"
application.register("tutor-stt", TutorSttController)

import TutorChatPanelController from "./tutor_chat_panel_controller"
application.register("tutor-chat-panel", TutorChatPanelController)

import TutorMessageActionsController from "./tutor_message_actions_controller"
application.register("tutor-message-actions", TutorMessageActionsController)

import TutorBehaviorFeedbackController from "./tutor_behavior_feedback_controller"
application.register("tutor-behavior-feedback", TutorBehaviorFeedbackController)

import SectionJumpController from "./section_jump_controller"
application.register("section-jump", SectionJumpController)
